/**
 * useLists — listas do usuário por módulo (GET /app/list?module=). app.md §5.2.
 * Cache 30s; invalidada após captura/delete/rename.
 */
import { useQuery } from '@tanstack/react-query';
import { api, unwrap } from '../lib/apiClient';
import { queryKeys } from '../lib/queryClient';
import { mergeLocalListCounts } from '../data/localList';
import { useSessionStore } from '../stores/sessionStore';
import type { SearchList } from '../types/searchList';
import type { ListModule } from '../config/constants';

async function fetchLists(
  module: ListModule,
  userId: string,
  signal: AbortSignal,
): Promise<SearchList[]> {
  const result = await api.get<SearchList[]>(`app/list/?module=${encodeURIComponent(module)}`, {
    signal,
    allowEmpty: true, // [] é resposta legítima (usuário sem listas)
  });
  const data = unwrap(result);
  return mergeLocalListCounts(Array.isArray(data) ? data : [], userId, module);
}

export function useLists(module: ListModule) {
  const userId = useSessionStore((state) => state.session?.userId ?? '');
  return useQuery({
    queryKey: [...queryKeys.lists(module), userId],
    queryFn: ({ signal }) => fetchLists(module, userId, signal),
    staleTime: 30_000,
  });
}
